import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface OrderCancelConfirmData {
  orderNo?: string;
  subOrderNo?: string;
}

@Component({
  selector: 'megastore-admin-order-cancel-confirm',
  templateUrl: './order-cancel-confirm.component.html',
  styleUrls: ['./order-cancel-confirm.component.scss']
})
export class OrderCancelConfirmComponent implements OnInit {
  title = '';
  message = '';
  orderLabel = '';
  cancelLabel = '';
  confirmLabel = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: OrderCancelConfirmData,
    private dialogRef: MatDialogRef<OrderCancelConfirmComponent, boolean>,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.title = this.text('CancelOrder', 'Cancel Order');
    this.message = this.text(
      'CancelOrderConfirmation',
      'Are you sure you want to cancel this order?'
    );
    this.cancelLabel = this.text('No', 'No');
    this.confirmLabel = this.text('YesCancelOrder', 'Yes, Cancel Order');

    const orderRef = this.data?.subOrderNo || this.data?.orderNo;
    if (orderRef) {
      this.orderLabel = `${this.text('OrderID', 'Order ID')}: #${orderRef}`;
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  private text(key: string, fallback: string): string {
    const translated = this.translateService.instant(key);
    return translated === key ? fallback : translated;
  }
}
